module.exports = __webpack_public_path__ + "assets/devices/Long_Range-e557b54f9064deb0b845c372d0883cec.svg";